<cp-base-notification contentClassName="info" wrapperClassName="info">
  <ng-container header>
    <ui-svg-icon
      iconClassName="icon-notification--training-cancelled"
      svgId="alert-filled"
    ></ui-svg-icon>
    <span>Your Training Has Been Cancelled </span>
  </ng-container>
  <ng-container *ngIf="isNotTrainingPage" cta>
    <a
      class="training-cancelled-notification__cta__link"
      routerLink="/training"
      fragment="your-bookings"
      >Re-Book<span
        class="training-cancelled-notification__cta__link__chevron"
      ></span
    ></a>
  </ng-container>
  <ng-container content>
    Your upcoming training has been cancelled. Please re-book your training as
    soon as possible to keep your training up to date and ensure you can
    continue working with us.
  </ng-container>
</cp-base-notification>
